import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { BaseCard, BaseCardBody, BaseCardHeader } from '@unite-us/ui';
import { get } from 'lodash';
import { hasPaymentsUserAccess, crtb2605NotesComponentRefactor } from 'src/common/utils/FeatureFlags/flags';
import {
  createContactServiceCaseProvidedService,
  createContactServiceCaseInteraction,
} from 'actions/Case/Contact/Group';
import { createContactInteraction } from 'actions/Contact/Group';
import AddCirclePlusButton from 'common/display/Profile/components/AddCirclePlusButton';
import Interactions from 'common/form/Interactions';
import { INTERACTION_TYPES } from 'src/components/Notes/constants';
import Notes from 'src/components/Notes/Notes';
import useFacesheetInteractions from 'src/components/Facesheet/Overview/components/actions/useFacesheetInteractions';

export function NotesSection({
  contact,
  contactCases,
  groupId,
  useAdapter,
  usePaymentsUserRole,
  createContactInteraction: createContactInteractionAction,
  createContactServiceCaseInteraction: createContactServiceCaseInteractionAction,
  createContactServiceCaseProvidedService: createContactServiceCaseProvidedServiceAction,
}) {
  const {
    interactionList,
    caseOptions,
    setShowInteractions,
    showInteractions,
  } = useFacesheetInteractions({
    contact,
    contactCases,
    usePaymentsUserRole,
    groupId,
    createContactInteraction: createContactInteractionAction,
    createContactServiceCaseInteraction: createContactServiceCaseInteractionAction,
    createContactServiceCaseProvidedService: createContactServiceCaseProvidedServiceAction,
  });

  if (!contact?.id) {
    return null;
  }

  const noteInteractionList = interactionList.filter((item) => (
    [INTERACTION_TYPES.INTERACTION, INTERACTION_TYPES.GENERAL].includes(item.value)
  ));

  const openNoteComposer = () => setShowInteractions(true);
  const closeNoteComposer = () => setShowInteractions(false);

  return (
    <BaseCard>
      {!useAdapter && (
        <BaseCardHeader title={<span className="text-base font-semibold leading-6 text-brand-blue">Notes</span>}>
          <AddCirclePlusButton
            id="add-social-care-plan-note-button"
            labelText="Add Note"
            addHandler={openNoteComposer}
          />
        </BaseCardHeader>
      )}
      <BaseCardBody>
        <div className="px-5 py-5">
          {showInteractions && (
            <div className="mb-4">
              <Interactions
                showCard={false}
                detailType="profile"
                cardHeaderTitle="Add Note"
                caseOptions={caseOptions}
                contact={contact}
                interactionList={noteInteractionList}
                cancelFunction={closeNoteComposer}
                showAttachedToField={false}
                showAttachedToCases={false}
              />
            </div>
          )}
          <Notes
            providerId={groupId}
            subject={contact.id}
            subjectType="person"
            onAddNote={openNoteComposer}
            reworkedAddNotes
            notesContainerId="social-care-plan-notes-container"
            compactBottomSpacing
          />
        </div>
      </BaseCardBody>
    </BaseCard>
  );
}

NotesSection.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string,
  }),
  contactCases: PropTypes.arrayOf(PropTypes.object),
  createContactInteraction: PropTypes.func.isRequired,
  createContactServiceCaseInteraction: PropTypes.func.isRequired,
  createContactServiceCaseProvidedService: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  useAdapter: PropTypes.bool,
  usePaymentsUserRole: PropTypes.bool.isRequired,
};

NotesSection.defaultProps = {
  contact: null,
  contactCases: [],
  useAdapter: false,
};

const mapStateToProps = (state, ownProps) => ({
  contactCases: get(state, ['serviceCase', ownProps.contact?.id, 'data'], []),
  groupId: state.session.groupId,
  useAdapter: crtb2605NotesComponentRefactor(state),
  usePaymentsUserRole: hasPaymentsUserAccess(state),
});

export default connect(mapStateToProps, {
  createContactInteraction,
  createContactServiceCaseInteraction,
  createContactServiceCaseProvidedService,
})(NotesSection);
